import { controlPlayback, type Player } from "@scripts/playback";
import type { ComponentInit } from "@scripts/registry";

const videoPlayer = (video: HTMLVideoElement, signal: AbortSignal): Player => ({
	/* Rejects when the browser refuses to autoplay. The poster is already the correct render in
	   that case, so there is nothing to fall back to and nothing to report. */
	play: () => void video.play().catch(() => undefined),
	pause: () => video.pause(),
	onPlaying: (callback) => video.addEventListener("playing", callback, { signal }),
	teardown: () => {
		video.pause();
		video.currentTime = 0;
	},
});

export const initVideo: ComponentInit = (root) => {
	if (!(root instanceof HTMLVideoElement)) return;

	/* Set here as well as in the markup: an autoplay policy blocks a video the browser believes
	   is unmuted, and the property is what it reads — not the attribute. */
	root.muted = true;

	return controlPlayback(root, (signal) => videoPlayer(root, signal));
};
